import { NUM_OPEN_WIDGET, PATIENT_HEADER_HEIGHT } from './constants'; // those are the dashboard widget dimensions

export const widget1by1Height = 320;
export const widgetHeaderHeight = 35;
const headerMarginBottomHeight = 2;
const dashboardWidgetMargin = 4;
export const widgetHeaderOverhead = 35 + 2 + 4; // smallWidgetHeight = 279 px

export const smallWidgetHeight = widget1by1Height - widgetHeaderHeight - headerMarginBottomHeight - dashboardWidgetMargin;
export const fullSizeRatio = 0.95; // fullSizeHeight does not take into account the top Bar height Patient information

export const fullSizeHeight = fullSizeRatio * window.innerHeight - widgetHeaderHeight;
export const getFullSizeHeight = windowHeight => {
  const numOpenWidgets = Number(localStorage.getItem(NUM_OPEN_WIDGET));
  const patientHeaderHeight = Number(localStorage.getItem(PATIENT_HEADER_HEIGHT));
  const fullHeight = fullSizeRatio * ((windowHeight || window.innerHeight) - (patientHeaderHeight || 0)) - widgetHeaderHeight;
  return fullHeight / (numOpenWidgets || 1);
};